export default __webpack_public_path__ + "static/media/telegram.c5a9f3d1.mp3";